import { useState } from 'react';
import { useScrolled } from '../hooks';
import { C } from '../config/constants';

export default function Header({ onAdminClick }) {
  const scrolled = useScrolled();
  const [mobileOpen, setMobileOpen] = useState(false);

  const goTo = id => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    setMobileOpen(false);
  };

  return (
    <header style={{
      position: 'sticky', top: 0, zIndex: 1000,
      background: scrolled ? 'rgba(255,255,255,0.97)' : '#fff',
      backdropFilter: 'blur(12px)',
      boxShadow: scrolled ? C.shadowMd : '0 1px 0 #f0f0f0',
      transition: 'box-shadow 0.3s',
    }}>
      <div style={{
        maxWidth: 1100, margin: '0 auto',
        display: 'flex', alignItems: 'center',
        padding: '0 1.5rem', height: scrolled ? '60px' : '70px',
        transition: 'height 0.3s',
      }}>
        {/* Logo */}
        <div onClick={onAdminClick} style={{
          display: 'flex', alignItems: 'center', gap: '0.65rem',
          flex: 1, cursor: 'default', userSelect: 'none',
        }}>
          <img src="assets/logo.png" alt="Logo" style={{
            height: scrolled ? '40px' : '50px',
            transition: 'height 0.3s',
          }}/>
          <div>
            <div style={{
              fontFamily: "'Fredoka', sans-serif",
              fontWeight: 600, color: C.blau,
              fontSize: scrolled ? '1.05rem' : '1.2rem',
              lineHeight: 1.1, transition: 'font-size 0.3s',
            }}>El Casalot</div>
            {!scrolled && (
              <div style={{
                fontSize: '0.65rem', color: C.textClar,
                fontWeight: 600, letterSpacing: '0.06em',
              }}>ESPLAI · RODA DE TER</div>
            )}
          </div>
        </div>

        {/* Nav desktop */}
        <nav style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}
          className="hide-mobile">
          {[
            { label: 'Qui som', id: 'qui-som' },
            { label: 'Què fem', id: 'que-fem' },
            { label: 'On som', id: 'on-som' },
            { label: 'Contacte', id: 'contacte' },
          ].map(({ label, id }) => (
            <button key={id} onClick={() => goTo(id)} style={{
              background: 'none', border: 'none',
              color: C.textMig, fontWeight: 600, fontSize: '0.88rem',
              padding: '0.4rem 0.75rem', cursor: 'pointer',
              fontFamily: 'inherit', borderRadius: C.radiusXs,
              transition: 'all 0.2s',
            }}
              onMouseEnter={e => { e.currentTarget.style.color = C.blau; e.currentTarget.style.background = C.blauClar; }}
              onMouseLeave={e => { e.currentTarget.style.color = C.textMig; e.currentTarget.style.background = 'none'; }}
            >{label}</button>
          ))}

          <button onClick={() => goTo('galeria')} style={{
            background: C.blau, color: '#fff',
            border: 'none', borderRadius: C.radiusXs,
            padding: '0.45rem 1.1rem',
            fontWeight: 700, fontSize: '0.88rem',
            cursor: 'pointer', fontFamily: 'inherit',
            marginLeft: '0.5rem',
            transition: 'all 0.2s',
          }}
            onMouseEnter={e => e.currentTarget.style.background = C.blauMig}
            onMouseLeave={e => e.currentTarget.style.background = C.blau}
          >📷 Galeria</button>
        </nav>

        {/* Hamburger mòbil */}
        <button onClick={() => setMobileOpen(p => !p)}
          className="show-mobile-flex"
          style={{
            display: 'none', background: 'none', border: 'none',
            fontSize: '1.5rem', cursor: 'pointer', padding: '4px',
            color: C.blau,
          }}>
          {mobileOpen ? '✕' : '☰'}
        </button>
      </div>

      {/* Menú mòbil */}
      {mobileOpen && (
        <div className="anim-fadeIn" style={{
          background: '#fff', borderTop: '1px solid #f0f0f0',
          padding: '1rem 1.5rem 1.5rem',
          display: 'flex', flexDirection: 'column', gap: '0.4rem',
        }}>
          {[
            { label: 'Qui som', id: 'qui-som' },
            { label: 'Què fem', id: 'que-fem' },
            { label: 'On som', id: 'on-som' },
            { label: 'Contacte', id: 'contacte' },
            { label: '📷 Galeria', id: 'galeria', highlight: true },
          ].map(({ label, id, highlight }) => (
            <button key={id} onClick={() => goTo(id)} style={{
              background: highlight ? C.blau : 'none',
              color: highlight ? '#fff' : C.text,
              border: 'none', borderRadius: C.radiusXs,
              padding: '0.75rem 1rem', textAlign: 'left',
              fontWeight: 700, fontSize: '1rem',
              cursor: 'pointer', fontFamily: 'inherit',
            }}>{label}</button>
          ))}
        </div>
      )}
    </header>
  );
}